import { Box, VStack, Heading, useToast } from "@chakra-ui/react";
import EventForm from "./components/EventForm";
import { AdminEventsEndpoints, fetcher } from "@olagg/api-hooks";
import { ApiEvent } from "@olagg/db-types";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../consts/routes";

const CreateEvent = () => {
    const toast = useToast();
    const navigate = useNavigate();

    const onSubmit = (dataForm: Partial<ApiEvent>, rescheduled: boolean) =>
        fetcher(AdminEventsEndpoints.create(dataForm, rescheduled))
            .then(() => {
                toast({
                    title: 'Evento',
                    colorScheme: 'olaggPink',
                    status: 'success',
                    description: `Evento creado con éxito`,
                    position: 'bottom-right'
                });
                window.location.href = ROUTES.EVENTS.all;
            })
            .catch((error: Error) => {
                toast({
                    title: 'Error',
                    colorScheme: 'olaggYellow',
                    status: 'error',
                    description: error.error,
                    position: 'bottom-right'
                });
            })

    return (
        <Box w={'full'} pb={4} minH='600px'>
            <VStack color={'white'} w={'full'}>
                <Heading my={2}>Crear evento</Heading>
                <EventForm onSubmit={onSubmit} />
            </VStack>
        </Box>
    )
};

export default CreateEvent;